import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { UPLOAD_PROFILE_PHOTO } from '../../../../../constants/index';

export default (userProfileId: any) => {
  const dispatch = useDispatch();

  return useCallback(
    (imageFile, onSuccess) => {
      dispatch({
        type: UPLOAD_PROFILE_PHOTO,
        imageFile,
        userProfileId,
        onSuccess,
      });
    },
    [dispatch, userProfileId]
  );
};
